module.exports = __webpack_public_path__ + "img/TongDing-icon.d9628456.png";